<template lang="pug">
  div
    .sidebar-layout
      .sidebar-layout__sidebar-wrapper
        farm-sidebar
      .sidebar-layout__views-wrapper
        router-view
    router-view(
      name="full")
</template>

<script>
import { mapActions } from 'vuex'

import FarmSidebar from '@/components/layouts/farm-sidebar/FarmSidebar'

export default {
  name: 'ClientFarm',

  components: {
    FarmSidebar
  },

  async mounted () {
    if (this.$route.path.includes('farm') && this.isClient) {
      const farmId = this.$route.params.farm_id
      const farmData = await this.getFarm(farmId)
      if (farmData) {
        this.$store.dispatch('account/setTimezone', farmData.timezone)
      }
    }
  },

  methods: {
    ...mapActions('farms', [
      'getFarm'
    ])
  }
}
</script>
